import { configureStore, combineReducers } from "@reduxjs/toolkit";
import contactSlice from "./slices/contactSlice";
import supplierSlice from "./slices/supplierSlice";
import snackbarSlice from "./slices/snackbarSlice";
import entityReducer from "./slices/entitySlice";
import entitySlice from "./slices/entitySlice";
import productSlice from "./slices/productSlice";
import addressSlice from "./slices/addressSlice";
const rootReducer = combineReducers({
  // No slices yet, add them here later
  contact: contactSlice,
  supplier: supplierSlice,
  entity: entitySlice,
  products: productSlice,
  address: addressSlice,
  snackbar: snackbarSlice, // Snackbar/ Toast slice reducer
});

export const store = configureStore({
  reducer: rootReducer,
  entity: entityReducer,
  devTools: process.env.NODE_ENV === "development", // Enable Redux DevTools in development mode
});

export default store;
